<template>
  <vs-popup class="customer-create-product-detail-pop-up"
            id="popup"
            title="CREATE CUSTOMER PRODUCT DETAIL"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateProductDetail)" autocomplete="off">

          <div class="vx-row mb-2">
            <div class="vx-col md:w-1full w-full md:mb-0">
              <ValidationProvider vid="formulation_id" name="formulation_id" rules="required" v-slot="{ errors }">
                <small class="label">Product</small>
                <v-select :filter-by="myFilter" :clearable="false" name="formulation_id" placeholder=""
                          label="formulation_code" v-model="createForm.formulation_id" :reduce="option => option.id"
                          :options="product_list" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.formulation_code}} - {{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="product_code" name="product_code" rules="required" v-slot="{ errors }">
                <small class="label">Product code</small>
                <vs-input v-model="createForm.product_code"  name="product_code" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="product_name" name="product_name" rules="required" v-slot="{ errors }">
                <small class="label">Product name</small>
                <vs-input  v-model="createForm.product_name" class="w-full"  name="product_name" type="text" label=""  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>


          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      product_list: [],
      createForm: {},
    }
  }

export default {
  name: 'CreateCustomerProductDetailsPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id) {
      try {
        Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.id = id
        await this.fetchProductList()
        this.open = true;
      } catch (error) {

      }
    },

    async onClickCreateProductDetail () {
      const vue = this;
      this.$vs.loading()
       try {
         this.createForm.customer_id = this.id
         await CustomerRepository.createCustomerProductDetail(this.createForm)
         this.showSuccessMessage('Customer product detail created successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    async fetchProductList() {
      this.$vs.loading()
      const {data} = await CustomerRepository.getALlCustomerProductList(this.id, '')
      this.product_list =  data.data
      this.$vs.loading.close()
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.formulation_code.toLowerCase().indexOf(temp) > -1 ||
        option.name.toLowerCase().indexOf(temp) > -1
    },

  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .customer-create-product-detail-pop-up >>> .vs-popup {
    /*min-height: 40% !important;*/
    min-width: 40% !important;
  }

</style>
